module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+CiAgPHBhdGggZD0iTTEuMiA0LjZWMi4yYzAtLjU1LjQ1LTEgMS0xaDIuNCIvPgogIDxwYXRoIGQ9Ik0xMS40IDEuMmgyLjRjLjU1IDAgMSAuNDUgMSAxdjIuNCIvPgogIDxwYXRoIGQ9Ik0xNC44IDExLjR2Mi40YzAgLjU1LS40NSAxLTEgMWgtMi40Ii8+CiAgPHBhdGggZD0iTTQuNiAxNC44SDIuMmMtLjU1IDAtMS0uNDUtMS0xdi0yLjQiLz4KICA8cGF0aCBkPSJNMS4yIDhoMTMuNiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu_icons/14.svg
// module id = pH1C
// module chunks = 2